import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all meters
export const getMeters = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/meters`);
    return response.data;
  } catch (error) {
    console.error("Error fetching meters:", error.response?.data || error);
    throw error;
  }
};

// GET a single meter
export const getMeterById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/meters/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching meters:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new meter
export const createMeter = async (meterData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/meters`, meterData);
    return response.data;
  } catch (error) {
    console.error("Error creating meters:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing meter
export const updateMeter = async (id, meterData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/meters/${id}`, meterData);
    return response.data;
  } catch (error) {
    console.error("Error updating meters:", error.response?.data || error);
    throw error;
  }
};

// DELETE a meter
export const deleteMeter = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/meters/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting meters:", error.response?.data || error);
    throw error;
  }
};
